import React from 'react';
import { ParentElement } from '../../types';

interface TableRowProps extends ParentElement{}

const TableRow: React.FC<TableRowProps> = function ({ children }) {
  return (
    <tr>
      {children}
    </tr>
  );
};

export default TableRow;
